import { type RootState } from '../../stores/redux';

export const getTrackingState = (state: RootState) => state.tracking;

export const getHasTrackedCallStart = (state: RootState) =>
  state.tracking.hasTrackedCallStart;

export const getHasTrackedCallEnd = (state: RootState) =>
  state.tracking.hasTrackedCallEnd;

export const getPinCount = (state: RootState) => state.tracking.pinCount;

export const getUnpinCount = (state: RootState) => state.tracking.unpinCount;

export const getUserFlipCamera = (state: RootState) =>
  state.tracking.userFlipCamera;

export const getIsHidePreview = (state: RootState) =>
  state.tracking.isHidePreview;
